import React from 'react';
import TooltipComponent from '../Tooltip/TooltipComponent';
import styles from './IcoInfo.module.scss';

interface IcoInfo {
  onClick?: (e: React.MouseEvent) => void;
  tooltip?: string;
  ico: string;
}

const IcoInfo: React.FC<IcoInfo> = (props) => {
  const { onClick = () => {}, tooltip = "", ico } = props;
  return tooltip
    ? <TooltipComponent title={tooltip}>
        <i className={`di icon-information ${styles.IconInfo}`} onClick={onClick} />
      </TooltipComponent>
    : <i
      className={`di ${ ico === 'Warning' ? `icon-warnung-fehler ${styles.Warning} ` : 'icon-information'} ${styles.IconInfo}`}
      onClick={onClick}
    />;

};

export default React.memo(IcoInfo, (prev, next) => JSON.stringify(prev) === JSON.stringify(next));
